import { MarketingModuleDto, MarketingModuleItemDto } from '@/infrastructure/network/dto/HpMarketingModuleDto';

export function marketingModuleMapper(raw: MarketingModuleDto): MarketingModuleDto {
	return {
		modules: raw.modules.map(
			(item: any): MarketingModuleItemDto => ({
				uuid: item.uuid,
				hpMarketingUuid: item.hpMarketingUuid,
				websiteUrl: item.websiteUrl,
				logo: {
					uuid: item.logo.uuid,
					url: item.logo.url,
					moduleFor: item.logo.moduleFor
				}
			})
		)
	};
}
